/** The account identifier as it appears in a secret name.
 *
 * GCP's `replacer` turns each `/` into `_`, so an `_` left in the account
 * would let one account's secret prefix match another's: `ORG-A` would match
 * every secret of `ORG-A_B`. An account identifier has exactly one `-`, between
 * the organization and the account (see `components.ts`), so mapping `_` to
 * `-` keeps every account's segment distinct and free of `_`.
 */
const accountSegment = (accountId: string) => accountId.replace(/_/g, "-");

/** Canonical (AWS-style) Secret Manager id of an account's connector private
 * key, an unencrypted PKCS8 PEM. Other providers rewrite it with their
 * `replacer`. */
export const snowflakeAiPrivateKeySecretId = (accountId: string): string =>
  `p0/install/snowflake-ai/${accountSegment(accountId)}/private-key`;

/** Canonical prefix that every token secret of an account starts with. It
 * ends with a delimiter, so one account's prefix never matches another's
 * secrets. Other providers rewrite it with their `replacer`. */
export const snowflakeAiAccessTokenPrefix = (accountId: string): string =>
  `p0/access-token/snowflake-ai/${accountSegment(accountId)}/`;

/** The connector's name: the Cloud Run service's, and the Lambda function's
 * with `-aws`. */
export const snowflakeAiConnectorName = "p0-connector-snowflake-ai";
